/* eslint-disable */
import { memo, useState } from "react";
import { Box, Card, Typography, styled, useTheme } from "@mui/material";
import noDataImg from "../../Images/noDataImg.png";
import Cpc from "./TableSkeleton";

const BoxWrapper = styled(Box)(({ theme }) => ({
  height: "100%",
  "& .MainHead": {
    "& h2": {
      color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
      fontSize: "18px",
      fontWeight: 700,
      lineHeight: "1",
      padding: "24px 24px 0px 24px",
    },
  },
  "& .KeywordDataWrapper": {
    marginTop: "18px",
    // border: `1px solid ${theme.palette.divider}`,
    // borderRadius: "6px",
    "& .HeadData": {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      gap: "10px",
      padding: "12px 10px 10px",
      backgroundColor: theme.palette.primary.main + "2b",
      overflow: "hidden",
      //   borderRadius: "6px 6px 0 0",
      "& .keywords": {
        color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
        fontSize: "14px",
        fontWeight: 700,
        flex: "1",
        lineHeight: "1",
      },
      "& .SearchVolume": {
        color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
        fontSize: "14px",
        fontWeight: 700,
        width: "100px",
        textAlign: "right",
        lineHeight: "1",
      },
      "& .Difficulty": {
        color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
        fontSize: "14px",
        fontWeight: 700,
        width: "100px",
        textAlign: "right",
        lineHeight: "1",
      },
    },
    "& .BodyData": {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      gap: "10px",
      padding: "12px 10px 10px",
      borderBottom: `1px solid ${theme.palette.divider}`,
      //   "&:last-of-type": {
      //     borderBottom: "none",
      //   },
      "& .keywords": {
        color: theme.palette.primary.main,
        fontSize: "14px",
        fontWeight: 400,
        flex: "1",
        lineHeight: "20px",
        whiteSpace: "nowrap",
        width: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
      "& .SearchVolume": {
        color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
        fontSize: "14px",
        fontWeight: 400,
        width: "100px",
        textAlign: "right",
        lineHeight: "1",
      },
      "& .Difficulty": {
        color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
        fontSize: "14px",
        fontWeight: 400,
        width: "100px",
        textAlign: "right",
        lineHeight: "1",
      },
    },
  },
  "& .NoDataWrapper": {
    minHeight: "300px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    "& .ImgWrapper": {
      textAlign: "center",
      marginBottom: "10px",
      "& img": {},
    },
    "& .ContentWrapper": {
      "& h3": {
        color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
        textAlign: "center",
        marginBottom: "10px",
        fontSize: "16px",
        fontWeight: 600,
        lineHeight: "1",
      },
      "& p": {
        color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
        textAlign: "center",
        fontSize: "14px",
        marginBottom: "10px",
        "& span": {
          color: theme.palette.primary.main,
          fontWeight: 600,
        },
      },
    },
  },
}));
function CpcTable({ label, fetchRes, searchKeywords, noDataImg, loading = true }) {
  // const [loading, setLoading] = useState(true);
  const cpcData = fetchRes?.cpcKeywordDetails;
  const theme = useTheme();
  return (
    <BoxWrapper>
      <Card
        sx={{
          padding: "0px",
          border: `1px solid ${theme.palette.divider}`,
          boxShadow: "none !important",
          height: "100%",
        }}
      >
        <Box className="MainHead">
          <Typography component="h2">{label}</Typography>
        </Box>
        <Box className="KeywordDataWrapper">
          {loading ? (
            <Cpc />
          ) : Array.isArray(cpcData) && cpcData.length > 0 ? (
            <>
              <Box className="HeadData">
                <Typography component="span" className="keywords">
                  COUNTRIES
                </Typography>
                <Typography component="span" className="SearchVolume">
                  CPC_HIGH
                </Typography>
                <Typography component="span" className="Difficulty">
                  CPC_LOW
                </Typography>
              </Box>
              {cpcData.map(item => (
                <Box className="BodyData" key={item.id}>
                  <Typography component="span" className="keywords">
                    {item?.locationCountry || "N/A"}
                  </Typography>
                  <Typography component="span" className="SearchVolume">
                    {item?.cpc_high || 0}
                  </Typography>
                  <Typography component="span" className="Difficulty">
                    {item?.cpc_low || 0}
                  </Typography>
                </Box>
              ))}
            </>
          ) : (
            <Box className="NoDataWrapper">
              <Box className="ImgWrapper">
                <Typography component="img" src={noDataImg} alt="No data available" />
              </Box>
              <Box className="ContentWrapper">
                <Typography component="h3">No data</Typography>
                <Typography component="p">
                  We couldn't find any {label} for <Typography component="span">{searchKeywords}</Typography>
                </Typography>
              </Box>
            </Box>
          )}
        </Box>
      </Card>
    </BoxWrapper>
  );
}

export default memo(CpcTable);
